module.exports = __webpack_public_path__ + "static/media/subtract.ecf7a309.svg";